var map = {
	"./3x3basketball.svg": "ee6c",
	"./americanfootball.svg": "5a0e",
	"./aussie-rules.svg": "2125",
	"./australianrules.svg": "5d91",
	"./badminton.svg": "bbd6",
	"./baseball.svg": "4cd5",
	"./basketball.svg": "b134",
	"./beachvolleyball.svg": "51d2",
	"./bowls.svg": "1c67",
	"./boxing.svg": "94bb",
	"./cricket.svg": "20bc",
	"./darts.svg": "6c4d",
	"./esports.svg": "5311",
	"./football.svg": "ab74",
	"./formulaone.svg": "840b",
	"./futsal.svg": "e704",
	"./gaelicfootball.svg": "f139",
	"./handball.svg": "2bb8",
	"./hockey.svg": "6ce6",
	"./horse-racing.svg": "5a21",
	"./hurling.svg": "6a3e",
	"./icehockey.svg": "4ce6",
	"./live-in-play-star.svg": "503f",
	"./mixedmartialarts.svg": "37c2",
	"./motorsport.svg": "a0da",
	"./pickleball.svg": "363b",
	"./rugby.svg": "2f63",
	"./rugbyleague.svg": "b236",
	"./rugbyunion.svg": "bad1",
	"./snooker.svg": "d312",
	"./soccer.svg": "eb27",
	"./squash.svg": "d446",
	"./tabletennis.svg": "1706",
	"./tennis.svg": "ee76",
	"./tennisdoubles.svg": "1f7b",
	"./testcricket.svg": "80c6",
	"./volleyball.svg": "be18",
	"./waterpolo.svg": "64bc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "909e";